import React, { Component } from "react";
import withErrorHandler from "../../../hoc/withErrorHandler";
import Axios from "../../../config/axios";
import { Row, Table, Button, Tooltip } from "antd";
import searchColumns from "../../../helpers/searchColumns";
import { Link } from "react-router-dom";
import { EditOutlined, LoadingOutlined } from "@ant-design/icons";
const moment = require("moment");

class FinishedLetters extends Component {
  state = {
    letters: [],
    page: 1,
    pageSize: 20,
    pagination: {},
    searchText: "",
    searchedColumn: "",
    unit: "",
  };

  componentDidMount() {
    this.checkUnit();
  }

  checkUnit = () => {
    this.setState({ unit: this.props.user.info.unit_id }, () =>
      this.fetchLetters()
    );
  };

  fetchLetters = (filters = {}, sorter = {}) => {
    let params = {};
    // if(filters.letters_type) params.letters_type = filters.letters_type[0]
    if (filters.requester) params.requester = filters.requester[0];
    if (sorter.field && sorter.order) {
      params.sort_field = sorter.field;
      params.sort_order = sorter.order === "ascend" ? 1 : -1;
    }

    if (this.props.user.info.type === "operator") {
      params.faculty_id = this.state.unit;
    }

    if (this.props.user.info.type === "prodi") {
      params.major_id = this.state.unit;
    }

    Axios.get("/requested-letters", {
      params: {
        page: this.state.page,
        step: "finished",
        page_size: this.state.pageSize,
        ...params,
      },
    }).then((response) => {
      let { pagination } = this.state;
      pagination.total = response.data.total;
      pagination.pageSize = this.state.pageSize;
      this.setState(
        { letters: response.data.payload, pagination },
        this.getUnits
      );
    });
  };

  getUnits = async () => {
    const letters = this.state.letters.map((letter) => {
      return Axios.get(
        `/units?unit_id=${letter.faculty_id}&major_id=${letter.major_id}`
      )
        .then((response) => {
          return {
            ...letter,
            major: response.data.payload.name,
          };
        })
        .catch((e) => {
          return letter;
        });
    });

    Promise.all(letters).then((response) => {
      this.setState({ letters: response });
    });
  };

  handleChangeTable = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState(
      {
        pagination: pager,
        page: pager.current,
      },
      () => {
        this.fetchLetters(filters, sorter);
      }
    );
  };

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  render() {
    const columns = [
      {
        title: "NIM",
        dataIndex: "requester",
        sorter: true,
        ...searchColumns(
          "requester",
          this.handleSearch,
          this.handleReset,
          this.state.searchedColumn,
          this.state.searchText
        ),
      },
      {
        title: "Prodi",
        dataIndex: "major",
        sorter: true,
        render: (text) => text || <LoadingOutlined />,
      },
      {
        title: "Jenis Surat",
        // dataIndex: 'letters_name',
        sorter: true,
        render: (record) =>
          !record.rated && (record.thesis || record.thesis_defence) ? (
            <Tooltip title="Belum diberi nilai">
              <span style={{ fontWeight: "bold", color: "red" }}>
                {record.letters_name}
              </span>
            </Tooltip>
          ) : (
            record.letters_name
          ),
        // ...searchColumns('', this.handleSearch, this.handleReset, this.state.searchedColumn, this.state.searchText)
      },
      // {
      //     title: 'Tipe Surat',
      //     dataIndex: 'letters_type',
      //     sorter: true,
      //     filters:  [
      //         { text: 'Akademik', value: 'akademik' },
      //         { text: 'Kemahasiswaan', value: 'kemahasiswaan' },
      //     ],
      //     filterMultiple: false,
      //     render: type => {
      //         const colors = {
      //             akademik : 'blue',
      //             kemahasiswaan : 'green',
      //         }
      //         return <Tag color={colors[type]}>{type.toUpperCase()}</Tag>
      //     }
      // } ,
      {
        title: "Tanggal Selesai",
        dataIndex: "finished_date",
        sorter: true,
        render: (text) => (text ? moment(text).format("LLL") : "-"),
        // ...searchColumns('requester', this.handleSearch, this.handleReset, this.state.searchedColumn, this.state.searchText)
      },
      {
        title: "Detail Surat",
        render: (record) => (
          <>
            <Link
              to={"/admin/surat/detail/" + record._id}
              style={{ margin: "0px auto" }}
            >
              <Button type="primary" shape="round" icon={<EditOutlined />}>
                {" "}
                Detail
              </Button>
            </Link>
          </>
        ),
      },
    ];

    return (
      <>
        <Row style={{ padding: 10 }}>
          <Table
            rowKey="_id"
            style={{ width: "100%" }}
            columns={columns}
            dataSource={this.state.letters}
            loading={this.props.loading}
            pagination={this.state.pagination}
            onChange={this.handleChangeTable}
          />
        </Row>
      </>
    );
  }
}

export default withErrorHandler(FinishedLetters, Axios);
